import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormikDialog } from './FormikDialog';

export const FormikDeleteDialog = props => {
    const { dialogTitle, entityModel, ...rest } = props;
    const [title, setTitle] = useState(dialogTitle);

    useEffect(() => {
        if (!title && entityModel) {
            setTitle(<FormattedMessage id="entity.delete" values={{ entityModel: entityModel }} />);
        }
    }, []);

    return (
        <FormikDialog
            mode="delete"
            dialogTitle={title}
            {...rest}
        >
            {props.children}
        </FormikDialog>
    );
}